var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckIconChecked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/linear/tick-square"
  }, /*#__PURE__*/React.createElement("g", {
    id: "tick-square"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.12492 17.4166H11.8749C15.8333 17.4166 17.4166 15.8333 17.4166 11.875V7.12498C17.4166 3.16665 15.8333 1.58331 11.8749 1.58331H7.12492C3.16659 1.58331 1.58325 3.16665 1.58325 7.12498V11.875C1.58325 15.8333 3.16659 17.4166 7.12492 17.4166Z",
    stroke: "#292D32",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M6.1355 9.5L8.37591 11.7404L12.8647 7.25958",
    stroke: "#292D32",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckIconChecked);
export default __webpack_public_path__ + "static/media/check-icon-checked.03c142cfeb9b073c5dd81a43803cf47d.svg";
export { ForwardRef as ReactComponent };